<script>
    export let show = false;
</script>

{#if show}
<div class="validation-error" style="display:block">
  <slot>This information is required</slot>
</div>
{/if}